import React from "react";
import { useState } from "react";
import PropTypes from "prop-types";
import SquareCardFields from "./square_card_fields";
import { tokenizeSquareCard } from "../../utilities/square_helpers";
import { Button } from "../../odc-ui";
import { Frame } from "@bitesite/react-figstrap";

const SquareCardForm = ({ onSuccess, onCancelClick, theme }) => {
  const [submitting, setSubmitting] = useState(false);
  const [squareCard, setSquareCard] = useState();
  const [cardBrand, setCardBrand] = useState();

  const createSquareCard = (token) => {
    $.ajax({
      url: "/square_cards",
      method: "POST",
      data: {
        square_card: {
          token,
        },
      },
      success: () => {
        if (onSuccess) {
          onSuccess();
          setSubmitting(false);
        }
      },
      error: () => {
        setSubmitting(false);
        window.alert("Failed to add credit card");
      },
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    const token = await tokenizeSquareCard(squareCard);
    createSquareCard(token);
  };

  return (
    <div>
      <SquareCardFields
        onChange={(newSquareCard, newCardBrand) => {
          setSquareCard(newSquareCard);
          setCardBrand(newCardBrand);
        }}
      />

      <Frame gap={20} vertical>
        <div className="text-align-left">
          Please note that by adding your credit card, you authorize Ottawa Derm
          &amp; Surgery Centre Inc. to charge your credit card. You also understand that your
          information will be securely saved to file for future transactions on
          your account. Your information will be processed by our payment
          processor, Square, Inc.
        </div>

        <Frame gap={10}>
          <Button
            type={theme === "paige" ? "dark-paige" : "dark"}
            onClick={handleSubmit}
          >
            {submitting ? "Please wait..." : "Add Card"}
          </Button>
          {!submitting && (
            <Button
              type={theme === "paige" ? "light-paige" : "primary"}
              onClick={onCancelClick}
            >
              Cancel
            </Button>
          )}
        </Frame>
      </Frame>
    </div>
  );
};

SquareCardForm.propTypes = {
  onSuccess: PropTypes.func,
  onCancelClick: PropTypes.func,
  theme: PropTypes.string,
};

export default SquareCardForm;
